import { getDestinos } from "../services/categoriaService"
import {
    getPaqueteDiponiblesCategoriaAdmin,
    getPaqueteSuplementoDiponibles,
    getPaqueteFechasDiponibles,
    getPlazasDiponiblesClavePaquete,
    getExtrasDisponiblesClavePaquete,
    getPenalizacionCambioPaquete,
    putCambioPaquete
} from "../services/servicePaquete"
import { getCatalogoExtras } from "../services/serviceCatalog"
import { FormatoDiffMount } from "../utils/FormatFecha"
import { CURRENCY_CODE } from "../utils/getMoneda"
const dataInicial = {
    categoria: {},
    paquete: {},
    clavePaquete: "0",
    listaItems: [],
    montoTotal: 0,
    cantidadMenores: 0,
    pasajerosTotal: 0,
    cantidadAdultos: 0,
    cantidadMernor: 0,
    cantidadInfantes: 0,
    cantidadPasajeros: 0,
    cantidadMensualidad: 0,
    montoMensual: 0,
    fechaSalida: '0,0,0',
    categoriaExtra: "0",
    extra: "0",
    listaFechaSalida: [],
    listaSuplmentos: [],
    listaPaquetes: [],
    listaCategoria: [],
    listaHabitaciones: [],
    listaCategoriaExtras: [],
    listaExtrasDisponibles: [],
    penalizacion: {},
    exito: 0,
    
}

const CAMBIO_PAQUETE_ADD_INFANTES = "CAMBIO_PAQUETE_ADD_INFANTE"
const CAMBIO_PAQUETE_ADD_MENORES = "CAMBIO_PAQUETE_ADD_MENORES"
const CAMBIO_PAQUETE_ADD_ADULTOS = "CAMBIO_PAQUETE_ADD_ADULTOS"
const CAMBIO_PAQUETE_ADD_CATEGORIA = "CAMBIO_PAQUETE_ADD_CATEGORIA"
const CAMBIO_PAQUETE_ADD_MENSUALIDADES = "CAMBIO_PAQUETE_ADD_MENSUALIDADES"
const CAMBIO_PAQUETE_ADD_PAQUETE = "CAMBIO_PAQUETE_ADD_PAQUETE"
const CAMBIO_PAQUETE_ADD_ITEM = "CAMBIO_PAQUETE_ADD_ITEM"
const CAMBIO_PAQUETE_ADD_PASAJERO = "CAMBIO_PAQUETE_ADD_PASAJERO"
const CAMBIO_PAQUETE_ADD_FECHA_SALIDA = "CAMBIO_PAQUETE_ADD_FECHA_SALIDA"
const CAMBIO_PAQUETE_ADD_CATEGORIA_EXTRA = "CAMBIO_PAQUETE_ADD_CATEGORIA_EXTRA"
const CAMBIO_PAQUETE_ADD_EXTRA = "CAMBIO_PAQUETE_ADD_EXTRA"
const GET_CAMBIO_PAQUETE_CATEGORIA = "GET_CAMBIO_PAQUETE_CATEGORIA"
const GET_CAMBIO_PAQUETE_PAQUETES = "GET_CAMBIO_PAQUETE_PAQUETES"
const GET_CAMBIO_PAQUETE_SUPLMENTOS = "GET_CAMBIO_PAQUETE_SUPLMENTOS"
const GET_CAMBIO_PAQUETE_FECHA_SALIDA = "GET_CAMBIO_PAQUETE_FECHA_SALIDA"
const GET_CAMBIO_PAQUETE_HABITACIONES = "GET_CAMBIO_PAQUETE_HABITACIONES"
const GET_CABMIO_PAQUETE_CATEGORIA_EXTRAS = "GET_CABMIO_PAQUETE_CATEGORIA_EXTRAS"
const GET_CAMBIO_PAQUETE_EXTRAS_DISPONIBLES = "GET_CAMBIO_PAQUETE_EXTRAS_DISPONIBLES"
const GET_CAMBIO_PAQUETE_PENALIZACION = "GET_CAMBIO_PAQUETE_PENALIZACION"
const POST_CAMBIO_PAQUETE_CAMBIO = "POST_CAMBIO_PAQUETE_CAMBIO"
const RESET_CAMBIO_PAQUETE_STATE = "RESET_CAMBIO_PAQUETE_STATE"
const RESET_CAMBIO_PAQUETE_PENALIZACION = "RESET_CAMBIO_PAQUETE_PENALIZACION"

export default function cambiosPaqueteReducer(state = dataInicial, action) {
    switch (action.type) {
        case CAMBIO_PAQUETE_ADD_INFANTES:
            return { ...state, cantidadInfantes: action.payload.cantidadInfantes, cantidadPasajeros: action.payload.cantidadPasajeros }
        case CAMBIO_PAQUETE_ADD_MENORES:
            return { ...state, cantidadMenores: action.payload.cantidadMenores, cantidadPasajeros: action.payload.cantidadPasajeros }
        case CAMBIO_PAQUETE_ADD_ADULTOS:
            return { ...state, cantidadAdultos: action.payload.cantidadAdultos, cantidadPasajeros: action.payload.cantidadPasajeros }
        case POST_CAMBIO_PAQUETE_CAMBIO:
            return { ...state, exito: action.payload.exito }
        case RESET_CAMBIO_PAQUETE_STATE:
            return { ...state, penalizacion: action.payload.penalizacion, extra: action.payload.extra, fechaSalida: action.payload.fechaSalida, categoriaExtra: action.categoriaExtra }
        case RESET_CAMBIO_PAQUETE_PENALIZACION:
            return { ...state, penalizacion: action.payload.penalizacion }
        case GET_CAMBIO_PAQUETE_PENALIZACION:
            return { ...state, penalizacion: action.payload.penalizacion }
        case CAMBIO_PAQUETE_ADD_EXTRA:
            return { ...state, extra: action.payload.extra }
        case GET_CAMBIO_PAQUETE_EXTRAS_DISPONIBLES:
            return { ...state, listaExtrasDisponibles: action.payload.listaExtrasDisponibles }
        case CAMBIO_PAQUETE_ADD_CATEGORIA_EXTRA:
            return { ...state, categoriaExtra: action.payload.categoriaExtra }
        case GET_CABMIO_PAQUETE_CATEGORIA_EXTRAS:
            return { ...state, listaCategoriaExtras: action.payload.listaCategoriaExtras }
        case GET_CAMBIO_PAQUETE_HABITACIONES:
            return { ...state, listaHabitaciones: action.payload.listaHabitaciones }
        case CAMBIO_PAQUETE_ADD_CATEGORIA:
            return { ...state, categoria: action.payload.categoria }
        case CAMBIO_PAQUETE_ADD_MENSUALIDADES:
            return { ...state, cantidadMensualidad: action.payload.cantidadMensualidad, montoMensual: action.payload.montoMensual }
        case CAMBIO_PAQUETE_ADD_PAQUETE:
            return { ...state, paquete: action.payload.paquete, clavePaquete: action.payload.clavePaquete }
        case CAMBIO_PAQUETE_ADD_ITEM:
            return { ...state, listaItems: action.payload.listaItems, montoTotal: action.payload.montoTotal, montoMensual: action.payload.montoMensual }
        case CAMBIO_PAQUETE_ADD_FECHA_SALIDA:
            return { ...state, fechaSalida: action.payload.fechaSalida, cantidadMensualidad: action.payload.cantidadMensualidad, montoMensual: action.payload.montoMensual }
        case CAMBIO_PAQUETE_ADD_PASAJERO:
            return { ...state, cantidadPasajeros: action.payload.cantidadPasajeros, montoTotal: action.payload.montoTotal, pasajerosTotal: action.payload.pasajerosTotal }
        case GET_CAMBIO_PAQUETE_FECHA_SALIDA:
            return { ...state, listaFechaSalida: action.payload.listaFechaSalida }
        case GET_CAMBIO_PAQUETE_CATEGORIA:
            return { ...state, listaCategoria: action.payload.listaCategoria }
        case GET_CAMBIO_PAQUETE_PAQUETES:
            return { ...state, listaPaquetes: action.payload.listaPaquetes }
        case GET_CAMBIO_PAQUETE_SUPLMENTOS:
            return { ...state, listaSuplmentos: action.payload.listaSuplmentos }
        default:
            return state;
    }
}
export const addInfantesAction = ({ cantidad }) => (dispatch, getState) => {
    const { cantidadAdultos, cantidadMenores } = getState().cambiosPaquete
    dispatch({
        type: CAMBIO_PAQUETE_ADD_INFANTES,
        payload: {
            cantidadInfantes: cantidad,
            cantidadPasajeros: Number(cantidad) + Number(cantidadAdultos) + Number(cantidadMenores)
        }
    })
}
export const addMenoresAction = ({ cantidad }) => (dispatch, getState) => {
    const { cantidadInfantes, cantidadAdultos } = getState().cambiosPaquete
    dispatch({
        type: CAMBIO_PAQUETE_ADD_MENORES,
        payload: {
            cantidadMenores: cantidad,
            cantidadPasajeros: Number(cantidad) + Number(cantidadInfantes) + Number(cantidadAdultos)
        }
    })
}
export const addAdultosAction = ({ cantidad }) => (dispatch, getState) => {
    const { cantidadInfantes, cantidadMenores } = getState().cambiosPaquete
    dispatch({
        type: CAMBIO_PAQUETE_ADD_ADULTOS,
        payload: {
            cantidadAdultos: cantidad,
            cantidadPasajeros: Number(cantidad) + Number(cantidadInfantes) + Number(cantidadMenores)
        }
    })
}
export const addExtraAction = ({ extra }) => (dispatch) => {
    dispatch({
        type: CAMBIO_PAQUETE_ADD_EXTRA,
        payload: {
            extra,
        }
    })
}
export const addCategoriaExtraAction = ({ categoriaExtra }) => (dispatch) => {
    dispatch({
        type: CAMBIO_PAQUETE_ADD_CATEGORIA_EXTRA,
        payload: {
            categoriaExtra,
        }
    })
}
export const addFechaSalidaAction = ({ fechaSalida, fecha }) => (dispatch, getState) => {
    const total = getState().cambiosPaquete.montoTotal
    const mensualidad = FormatoDiffMount({ date: fecha })
    const mensualidades = (mensualidad === 0) ? 1 : mensualidad
    dispatch({
        type: CAMBIO_PAQUETE_ADD_FECHA_SALIDA,
        payload: {
            fechaSalida,
            cantidadMensualidad: mensualidades,
            montoMensual: total / mensualidades
        }
    })
}
export const addCantidadMensualidadesAction = ({ cantidadMensualidad }) => (dispatch, getState) => {
    const total = getState().cambiosPaquete.montoTotal
    dispatch({
        type: CAMBIO_PAQUETE_ADD_MENSUALIDADES,
        payload: {
            cantidadMensualidad,
            montoMensual: total / cantidadMensualidad
        }
    })
}
export const addCantiadPasajerosAction = ({ cantidadPasajeros }) => (dispatch, getState) => {
    const arrayItem = getState().cambiosPaquete.listaItems
    const totalPasajeros = getState().cambiosPaquete.pasajerosTotal
    const total = arrayItem.reduce((a, b) => {
        return a + (b.price * b.quantity)
    }, 0)
    dispatch({
        type: CAMBIO_PAQUETE_ADD_PASAJERO,
        payload: {
            cantidadPasajeros: Number(cantidadPasajeros),
            montoTotal: total,
            pasajerosTotal: Number(totalPasajeros)
        }
    })
}
export const addItemsAction = ({ listaItem }) => (dispatch, getState) => {
    const cantidadMensualidad = getState().cambiosPaquete.cantidadMensualidad
    const total = listaItem.reduce((a, b) => {
        return a + (b.price * b.quantity)
    }, 0)
    dispatch({
        type: CAMBIO_PAQUETE_ADD_ITEM,
        payload: {
            listaItems: listaItem,
            montoTotal: total,
            montoMensual: total / cantidadMensualidad
        }
    })
}
export const addCategoriaAction = ({ categoria }) => (dispatch) => {
    dispatch({
        type: CAMBIO_PAQUETE_ADD_CATEGORIA,
        payload: {
            categoria
        }
    })
}
export const addPaqueteAction = ({ paquete }) => (dispatch) => {
    dispatch({
        type: CAMBIO_PAQUETE_ADD_PAQUETE,
        payload: {
            paquete,
            clavePaquete: paquete.ClavePaquete ?? "0"
        }
    })
}
export const obtenerCategoriasAction = () => async (dispatch) => {
    return await getDestinos().then(Response => {
        dispatch({
            type: GET_CAMBIO_PAQUETE_CATEGORIA,
            payload: {
                listaCategoria: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerPaquetesAction = ({ IdCategoria }) => async (dispatch) => {
    return await getPaqueteDiponiblesCategoriaAdmin({ IdCategoria }).then(Response => {
        if (IdCategoria === 0) {
            dispatch({
                type: GET_CAMBIO_PAQUETE_PAQUETES,
                payload: {
                    listaPaquetes: []
                }
            })
            return null
        }

        dispatch({
            type: GET_CAMBIO_PAQUETE_PAQUETES,
            payload: {
                listaPaquetes: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerSuplementosAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getPaqueteSuplementoDiponibles({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_CAMBIO_PAQUETE_SUPLMENTOS,
            payload: {
                listaSuplmentos: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerFechaSalidaAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getPaqueteFechasDiponibles({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_CAMBIO_PAQUETE_FECHA_SALIDA,
            payload: {
                listaFechaSalida: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerHabitacionesAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getPlazasDiponiblesClavePaquete({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_CAMBIO_PAQUETE_HABITACIONES,
            payload: {
                listaHabitaciones: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerCategoriaExtrasAction = () => async (dispatch) => {
    return await getCatalogoExtras().then(Response => {
        dispatch({
            type: GET_CABMIO_PAQUETE_CATEGORIA_EXTRAS,
            payload: {
                listaCategoriaExtras: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerExtrasDisponiblesAction = ({ categoriaExtra, ClavePaquete }) => async (dispatch) => {
    return await getExtrasDisponiblesClavePaquete({ ClavePaquete, idCatExtra: categoriaExtra }).then(Response => {
        dispatch({
            type: GET_CAMBIO_PAQUETE_EXTRAS_DISPONIBLES,
            payload: {
                listaExtrasDisponibles: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const resetStateAction = () => (dispatch) => {
    dispatch({
        type: RESET_CAMBIO_PAQUETE_STATE,
        payload: {
            penalizacion: dataInicial.penalizacion,
            extra: dataInicial.extra,
            fechaSalida: dataInicial.fechaSalida,
            categoriaExtra: dataInicial.categoriaExtra,

        }
    })
}

export const aplicarCambioPaqueteAction = () => async (dispatch, getState) => {
    const Referencia = getState().cambios.referencia ?? "0"
    const paqueteSelect = getState().cambiosPaquete.paquete
    const deal_currency_code = CURRENCY_CODE[paqueteSelect?.Moneda.id_moneda]
    const amount = getState().cambiosPaquete.penalizacion?.MontoPaquete ?? 0
    const monto_mensual_a_pagar = getState().cambiosPaquete.penalizacion?.MontoPaquete / getState().cambiosPaquete.cantidadMensualidad
    const numero_de_mensualidades = getState().cambiosPaquete.cantidadMensualidad
    const numero_de_personas = getState().cambiosPaquete.cantidadPasajeros ?? 0
    const paquete_contratado = paqueteSelect?.envioPaqueteProveedor?.IdObjeto ?? "0"
    const numero_de_items = getState().cambiosPaquete.listaItems.length
    let listaItems = getState().cambiosPaquete.listaItems ?? []
    let suplementosEnviados = []
    const suplmentoSalida = listaItems.find(item => item.type === 'SALIDA')
    const arraySuuplementoSalida = suplmentoSalida.name.split("-")
    const fecha_de_salida = arraySuuplementoSalida[arraySuuplementoSalida.length - 1].trim()
    listaItems = listaItems.filter(item => item.type !== 'PAQUETE')
    suplementosEnviados = listaItems.map(item => {
        return {
            idSuplemento: item.id,
            amount: item.quantity
        }
    })
    return await putCambioPaquete({ Referencia, amount, monto_mensual_a_pagar, deal_currency_code, fecha_de_salida, numero_de_items, numero_de_mensualidades, numero_de_personas, paquete_contratado, suplementosEnviados }).then(Response => {
        dispatch({
            type: POST_CAMBIO_PAQUETE_CAMBIO,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerPenalizacionAction = () => async (dispatch, getState) => {
    const Referencia = getState().cambios.referencia ?? "0"
    const paqueteSelect = getState().cambiosPaquete.paquete
    const deal_currency_code = CURRENCY_CODE[paqueteSelect?.Moneda.id_moneda]
    const amount = getState().cambiosPaquete.montoTotal ?? 0
    const numero_de_personas = getState().cambiosPaquete.cantidadPasajeros ?? 0
    const paquete_contratado = paqueteSelect?.envioPaqueteProveedor?.IdObjeto ?? "0"
    let listaItems = getState().cambiosPaquete.listaItems ?? []
    let suplementosEnviados = []
    listaItems = listaItems.filter(item => item.type !== 'PAQUETE')
    suplementosEnviados = listaItems.map(item => {
        return {
            idSuplemento: item.id,
            amount: item.quantity
        }
    })
    return await getPenalizacionCambioPaquete({ Referencia, amount, deal_currency_code, numero_de_personas, paquete_contratado, suplementosEnviados }).then(Response => {
        dispatch({
            type: GET_CAMBIO_PAQUETE_PENALIZACION,
            payload: {
                penalizacion: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const resetPenalizacionAction = () => async (dispatch, getState) => {
    dispatch({
        type: GET_CAMBIO_PAQUETE_PENALIZACION,
        payload: {
            penalizacion: dataInicial.penalizacion
        }
    })
}
